/**
 * Generated runtime TestId mirror for frontend/src/pages/DelegationFormDialog.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const DelegationFormDialogTestIds = {
  deputyCombobox: "deputy-combobox",
  endDateInput: "end-date-input",
  permanentSwitch: "permanent-switch",
  reasonInput: "reason-input",
  selectedDeputies: "selected-deputies",
  startDateInput: "start-date-input",
  workflowStepSelect: "workflow-step-select",
  removeDeputy: (d_id: string) => `remove-deputy-${d_id}`,
  removeDeputyPrefix: () => "remove-deputy-" as TestIdPrefix
} as const;
